<template>
    <div class="premiedekkingsgraad">
        <div v-if="fonds && fonds.premiedekkingsgraad">
            <template v-if="isLow">
                <p>Nee, de premiedekkinsgraad is {{fonds.premiedekkingsgraad | formatNumber}} procent. Dat betekent dat voor iedere op termijn uit te keren euro er nu een tekort is van {{100 - fonds.premiedekkingsgraad | formatNumber}} cent. Dat tekort gaat ten koste van het vermogen van het fonds.
                </p>
            </template>
            <template v-else>
                <p>Ja, de premiedekkingsgraad is {{fonds.premiedekkingsgraad | formatNumber}}%. </p>
                <p>Bij een premiedekkingsgraad van 100 procent of meer is de premie voldoende om de kosten van nieuwe pensioenopbouw te dekken.
                </p>
            </template>
        </div>
        <p v-else>De premiedekkingsgraad van dit fonds is onbekend.</p>
        <div v-show="fonds && fonds.premiedekkingsgraad" class="premiedekkingsgraad__chart" ref="chart"></div>
        <p>De Nederlandsche Bank heeft in 2017 berekend dat bij alle fondsen samen in heel 2017 ongeveer € 8 miljard euro te weinig aan premie is betaald. Dat ging ten koste van het vermogen van deze fondsen.</p>
    </div>
</template>

<script>
    import Highcharts from 'highcharts';

    export default {
        name: "Premiedekkingsgraad",
        props: {
            fonds: Object
        },
        watch: {
            fonds(_fonds) {
                if (_fonds) {
                    this.updateChart(_fonds);
                }
            }
        },
        computed: {
            isLow() {
                return this.fonds.premiedekkingsgraad < 100;
            }
        },
        mounted() {
            let series;

            if (this.fonds) {
                series = this.getSeries(this.fonds);
            } else {
                series = []
            }
            this.chart = Highcharts.chart(this.$refs.chart, {
                chart: {
                    type: 'bar',
                    height: 150,
                    margin: [0, 1, null, 1]
                },
                title: {
                    text: ''
                },
                subtitle: {
                    text: ''
                },
                legend: {
                    enabled: false
                },
                xAxis: {
                    visible: false
                },
                tooltip: {
                    enabled: false
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: '%'
                    }
                },
                credits: {
                    enabled: false
                },
                series
            });
        },
        methods: {
            updateChart(fonds) {
                /* Update chart extremes */
                const extremes = this.getMinMax(fonds);
                this.chart.yAxis[0].setExtremes(extremes.min, extremes.max);

                const series = this.getSeries(fonds);
                this.chart.update({series}, true, true);
            },
            getMinMax(fonds) {
                const min = 0;
                const max = Math.max(fonds.premiedekkingsgraad + 10, 120);
                return { min, max };

            },
            getSeries(fonds) {

                return [{
                    name: 'Premiedekkingsgraad',
                    data: [fonds.premiedekkingsgraad],
                    color: fonds.premiedekkingsgraad < 100 ? '#E32A2A' : '#6DCD3A'
                }]
            }
        }
    }
</script>

<style lang="stylus">
.premiedekkingsgraad__chart
    margin-top (2 * $gutter)
</style>